import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import PaiyaPage from "components/pages/Paiya/PaiyaPage";
import { RootState } from "redux/reducers/RootReducer";
import { IPaiyaMOVGameStatusPayload } from "interfaces/Index";

export const mapStateToProps = (state: RootState): any => {
  const { zone } = state;
  return {
    isLoading: state.paiyaConfig.isLoading,
    isError: state.paiyaConfig.isError,
    error: state.paiyaConfig.error,
    isEdit: state.paiyaConfig.isEdit,
    //cities list
    citiesList: zone.citiesList,
    isCityListFetched: state.zone.isCityListFetched,
    //paiya types list
    paiyaTypesList: state.paiyaConfig.paiyaTypesList,
    isPaiyaTypesFetched: state.paiyaConfig.isPaiyaTypesFetched,
    //paiya config
    isPaiyaConfigAdded: state.paiyaConfig.isPaiyaConfigAdded,
    isPaiyaConfigFetch: state.paiyaConfig.isPaiyaConfigFetch,
    paiyaConfig: state.paiyaConfig.paiyaConfig,
    //gift csv state
    isGiftCsvLoading: state.paiyaConfig.isGiftCsvLoading,
    isGiftCsvUploaded: state.paiyaConfig.isGiftCsvUploaded,
    isGiftCsvError: state.paiyaConfig.isGiftCsvError,
    giftCsvError: state.paiyaConfig.giftCsvError,
    //store csv state
    isStoreCsvLoading: state.paiyaConfig.isStoreCsvLoading,
    isStoreCsvUploaded: state.paiyaConfig.isStoreCsvUploaded,
    isStoreCsvError: state.paiyaConfig.isStoreCsvError,
    storeCsvError: state.paiyaConfig.storeCsvError,
    customerConfig: state.customer.customerConfig,
    movStatusError: state.paiyaConfig.movStatusError,
    isMovStatusLoading: state.paiyaConfig.isMovStatusLoading
    // paiyaConfig: state.paiyaConfig.paiyaConfig,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchCities: () => dispatch(actions.fetchCities()),
    fetchPaiyaTypes: () => dispatch(actions.fetchPaiyaTypesAction()),
    fetchPaiyaConfig: (gameVariantType: string, cityId: string) =>
      dispatch(actions.fetchPaiyaConfigAction(gameVariantType, cityId)),
    createPaiyaStoreCsv: (
      gameVariantType: string,
      cityId: string,
      payload: FormData,
      url: string
    ) =>
      dispatch(
        actions.createPaiyaStoreUploadCsvAction(
          gameVariantType,
          cityId,
          payload,
          url
        )
      ),
    createPaiyaGiftCsv: (
      gameVariantType: string,
      cityId: string,
      payload: FormData,
      url: string
    ) =>
      dispatch(
        actions.createPaiyaGiftUploadCsvAction(
          gameVariantType,
          cityId,
          payload,
          url
        )
      ),
    createPaiyaMovGameStatus: (
      gameVariantType: string,
      cityId: string,
      payload: IPaiyaMOVGameStatusPayload
    ) =>
      dispatch(
        actions.createPaiyaMovGameStatusAction(gameVariantType, cityId, payload)
      ),
    fetchCustomerChannelAction: () => dispatch(actions.fetchCustomerConfig()),
  };
};

const PaiyaContainer = connect(mapStateToProps, mapDispatchToProps)(PaiyaPage);
export default PaiyaContainer;
